import React from 'react';
import PropTypes from 'prop-types';
import { NotificationFullscreen } from '@sumup/circuit-ui';

import { ReactComponent as Image } from '../../assets/general-error.svg';

const ErrorView = ({ showGoBackButton = false }) => {
  const actions = showGoBackButton
    ? {
        primary: {
          children: 'Go back',
          onClick: function goBack() {
            window.history.back();
          },
        },
      }
    : null;

  return (
    <NotificationFullscreen
      headline={{
        as: 'h1',
        label: 'Something went wrong',
      }}
      body="Sorry, there was a problem with your request. Please go back to the merchant website and try again."
      image={{
        svg: Image,
        alt: '',
      }}
      actions={actions}
    />
  );
};

ErrorView.propTypes = {
  showGoBackButton: PropTypes.bool,
};

export default ErrorView;
